import { render } from "./StudentTrainingDurationView.vue?vue&type=template&id=bc06ca06&scoped=true"
import script from "./StudentTrainingDurationView.vue?vue&type=script&lang=js"
export * from "./StudentTrainingDurationView.vue?vue&type=script&lang=js"

import "./StudentTrainingDurationView.vue?vue&type=style&index=0&id=bc06ca06&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc06ca06"]])

export default __exports__